import CommonLayout from "layouts/DashboardLayout";
import AddStrainForm from "./AddStrainForm";
import { STILO } from "utilities/constants";
import { getData } from "utilities/common";
import AddStrainStiloForm from "./AddStrainStiloForm";

export default function AddStrain() {
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  return (
    <CommonLayout>
      {
        isStilo ?
        <AddStrainStiloForm />
        :
        <AddStrainForm />
      }
    </CommonLayout>
  )
}